import React from 'react';
import PropTypes from 'prop-types';
import * as S from './Alert.styles';
import Icon from '../Icon/Icon';
import H from '../Texts/H/H';
import P from '../Texts/P/P';
import Link from '../Link/Link';

const Alert = ({
  variant,
  icon,
  title,
  description,
  textLink,
  href,
  onClickLink,
}) => {
  const nameIcons = {
    info: 'info_circle_outline',
    success: 'check_circle_outline',
    warning: 'error_circle_outline',
    danger: 'cancel_circle_outline',
  };

  const renderIcon = () => (
    <S.IconBaseAlert>
      <Icon
        variant={variant}
        name={nameIcons[variant]}
        modifier='regular'
        width={24}
        height={24}
      />
    </S.IconBaseAlert>
  );

  const renderTitle = () => (
    <S.AlertTitle>
      <H variant={variant} modifier='regular' type='6' weight='bold'>
        {title}
      </H>
    </S.AlertTitle>
  );

  const renderDescription = () => (
    <P variant={variant} modifier='regular' type='2' weight='regular'>
      {description}
    </P>
  );

  const renderTextLink = () => (
    <S.LinkAlert>
      <Link
        variant='primary'
        href={href}
        target='_blank'
        size='sm'
        onClick={onClickLink}
      >
        {textLink}
      </Link>
    </S.LinkAlert>
  );

  return (
    <S.Alert variant={variant}>
      {icon && renderIcon()}
      <S.TextWrapper>
        {title && renderTitle()}
        {description && renderDescription()}
        {textLink && renderTextLink()}
      </S.TextWrapper>
    </S.Alert>
  );
};

Alert.defaultProps = {
  variant: 'info',
};

Alert.propTypes = {
  icon: PropTypes.bool,
  variant: PropTypes.oneOf(['info', 'success', 'warning', 'danger']).isRequired,
  title: PropTypes.string,
  description: PropTypes.string.isRequired,
  textLink: PropTypes.string,
  href: PropTypes.string,
  onClickLink: PropTypes.func,
};

export default Alert;
